import { useTranslation } from 'react-i18next';

import { NotificationFeed } from '@/components/notifications/NotificationFeed';
import { useMarkAllNotificationsRead } from '@/hooks/useMarkAllNotificationsRead';
import { Button } from '@/components/ui/Button';
import { Card } from '@/components/ui/Card';
import { PageHeader } from '@/components/ui/PageHeader';
import { humanizeError } from '@/lib/errors';
import { useIsMobile } from '@/hooks/useIsMobile';
import { MTitle } from '@/components/mobile/MobileKit';

/**
 * Лента уведомлений куратора (11.09.2026). До этого у куратора её не было
 * вовсе, хотя сервер строки для него уже пишет: сдачи домашки его учеников,
 * с пометкой «Пересдано».
 *
 * Настроек каналов здесь нет намеренно: переключатели на странице ученика —
 * ученические (уроки, чат, разговор), куратору они ничего не значат.
 */
export function CuratorNotificationsPage() {
  const { t } = useTranslation();
  const markAll = useMarkAllNotificationsRead();
  const isMobile = useIsMobile();

  // ── Телефон (docs/CURATOR-MOBILE-DESIGN.md §4.7) ──────────────────────────
  // «Назад» — в «Ещё»: на телефоне уведомления открываются оттуда или колокольчиком главной.
  if (isMobile) {
    return (
      <div className="space-y-3">
        <MTitle
          back="/curator/more"
          title={t('notifications.title')}
          right={
            <button
              type="button"
              onClick={() => markAll.mutate()}
              disabled={markAll.isPending}
              className="flex h-11 flex-none items-center gap-1 rounded-full px-3 text-[12.5px] font-semibold text-primary disabled:opacity-50"
            >
              <span className="material-symbols-outlined text-[18px]">mark_email_read</span>
              {t('notifications.markAllRead')}
            </button>
          }
        />
        {markAll.isError && <p className="px-0.5 text-[13px] text-error">{humanizeError(markAll.error)}</p>}
        <NotificationFeed role="curator" rows />
      </div>
    );
  }

  return (
    <>
      <PageHeader
        title={t('notifications.title')}
        actions={
          <Button variant="ghost" onClick={() => markAll.mutate()} loading={markAll.isPending}>
            <span className="material-symbols-outlined">mark_email_read</span>
            {t('notifications.markAllRead')}
          </Button>
        }
      />
      {markAll.isError && (
        <Card variant="subtle" className="mb-2 text-sm text-error">
          {humanizeError(markAll.error)}
        </Card>
      )}
      <NotificationFeed role="curator" />
    </>
  );
}
